<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Mis Artículos del Blog
          </h2>
          <DataTable
            ref="dt"
            :value="itemsList"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} artículos"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  v-tooltip.rigth="'Agregar nuevo'"
                   name="nuevo"
                />                
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="titulo" header="Titulo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Titulo</span>
                {{ slotProps.data.titulo }}
              </template>
            </Column>
            <Column field="autor" header="Autor" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Autor</span>
                {{ slotProps.data.autor }}
              </template>
            </Column>
            <Column field="resumen" header="Resumen" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Resumen</span>
                {{ slotProps.data.resumen }}
              </template>
            </Column>
            <Column field="referencias" header="Referencias" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Referencias</span>
                {{ slotProps.data.referencias }}
              </template>
            </Column>            
            <Column field="activo" header="Activo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Activo</span>
                {{ slotProps.data.activo == 0 ? "No" : "Si" }}
              </template>
            </Column>
            <Column field="publicado" header="Publicado" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Publicado</span>
                {{ slotProps.data.publicado == 0 ? "No" : "Si" }}
              </template>
            </Column>            
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editItem(slotProps.data)"
                  v-tooltip.top="'Editar'"
                   name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteItem(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                   name="eliminar"
                />
              </template>
            </Column>
          </DataTable>          
          <Dialog
            :visible="deleteItemDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="item"
                >Esta seguro que desea eliminar el artículo seleccionado
                <b>{{ item.titulo }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteItemDialog = false"
                 name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteItemSelected"
                 name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticulosService from "../service/articulos.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      articulosService: null,
      filters: {},
      item: {},
      itemsList: [],      
      deleteItemDialog: false,      
      loading: false,      
    };
  },
  created() {
    this.articulosService = new ArticulosService();
  },
  mounted() {
    this.recuperarItemsForList();
  },
  methods: {
    recuperarItemsForList() {
      this.articulosService
        .allMyArticulos()
        .then((result) => {
          if (result.data.data) {
            this.itemsList = [...result.data.data];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItemSelected() {
      this.articulosService
        .eliminarArticulo({ id: this.item.id })
        .then(() => {
          this.itemsList = this.itemsList.filter(
            (val) => val.id !== this.item.id
          );
          this.deleteItemDialog = false;
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Item eliminado",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openNew(){
      this.$router.push({name:'crear_articulos'})
    },
    editItem(data){
      console.log('Editar articulo',data)
      this.$router.push({name:'editar_articulos',params:{id:data.id}})
    }
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
